(function ($) { 

  Drupal.behaviors.homeTeaser = {
	    attach: function (context) {
	    		Drupal.behaviors.homeTeaserCreator(context);
	    		
	    }
  };
  
  Drupal.behaviors.homeTeaserCreator = function (context){
		$(".homeTeaser", context).each(function (index){
			var mainContent = $(this);
			var tabletMobileOverlayOpacity = $(mainContent).data("tablet-mobile-overlay-opacity");
			var tabletMobileOverlayColor = $(mainContent).data("tablet-mobile-overlay-color");
			var desktopOverlayOpacity = $(mainContent).data("desktop-overlay-opacity");
			var desktopOverlayColor = $(mainContent).data("desktop-overlay-color");
			var teaserBackgroundColor = $(mainContent).data("background-color");
			var maskType = $(mainContent).data("mask-type");
            var imagePath = $(mainContent).data("image-path");
            
            //background color?!
            mainContent.removeClass("white-bgr");
            mainContent.removeClass("red-bgr");
            mainContent.removeClass("black-bgr");

            if(teaserBackgroundColor == "white"){
                mainContent.addClass("white-bgr");
            }
            else if(teaserBackgroundColor == "red"){
                mainContent.addClass("red-bgr");
            }
            else if(teaserBackgroundColor == "black"){
                mainContent.addClass("black-bgr");
			}		
			
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	$(mainContent).height($(window).height());
	    	Drupal.behaviors.linkButtonCreator($(mainContent));

	    	//When the mask type is full
	    	var fullContentsHTML = "";
	    	if(maskType == "full"){
	    		$(".homeTeaserMain",mainContent).addClass("fullHeight");
	    		$(".homeTeaserTextMain",mainContent).addClass("main-content-offset fullHeight");
	    		$(".homeTeaserImageWrapper",mainContent).addClass("fullHeight position-absolute overflow-hidden");
	    		fullContentsHTML += '<div class="homeTeaserFullMask fullWidth fullHeight" style="background-image:url(' + imagePath + ')"></div>';
	    		fullContentsHTML += '<div class="fullWidth fullHeight homeTeaserOverlay"></div>';
	    		$(".homeTeaserImageWrapper",mainContent).append(fullContentsHTML);
	    	} else if(maskType == "circle"){
	    		$(".homeTeaserMain",mainContent).addClass("main-content-offset fullHeight position-relative");
	    		$(".homeTeaserTextMain",mainContent).addClass("fullHeight");
	    		
	    		$(".homeTeaserImageWrapper",mainContent).addClass("fullHeight");
	    		$(".homeTeaserImageWrapper",mainContent).append('<div class=" homeTeaserMainImageMask no-padding-left-right position-relative fullHeight"><div class="homeTeaserCircleMask" style="background-image:url(' + imagePath + ')"></div></div>');

	    		Drupal.behaviors.calcHomeTeaserCircleType(mainContent);
	    	} else if(maskType == "rectangle"){
	    		$(".homeTeaserMain",mainContent).addClass("main-content-offset fullHeight position-relative");
	    		$(".homeTeaserTextMain",mainContent).addClass("fullHeight");
	    		$(".homeTeaserImageWrapper",mainContent).addClass("fullHeight fullWidth");
	    		$(".homeTeaserImageWrapper",mainContent).append('<div class="homeTeaserMainImageMask fullHeight no-padding-left-right position-relative"><div class="homeTeaserRectangleMask2" style="background-image:url(' + imagePath + ')"></div><div class="homeTeaserRectangleMask1" style="background-image:url(' + imagePath + ')"></div></div>');
	    		Drupal.behaviors.calcHomeTeaserRectType(mainContent);
	    	}
	    	//And Everytime the user resizes the window
	    	$(window).resize(function() {
	    		$(mainContent).height($(window).height());
	    		if(maskType =="circle"){
	    			Drupal.behaviors.calcHomeTeaserCircleType(mainContent);
		    	}else if(maskType =="rectangle"){
		    		Drupal.behaviors.calcHomeTeaserRectType(mainContent);
		    	}else{
		    		Drupal.behaviors.calcHomeTeaserFullType(mainContent);
		    	}
	    	});
			$(mainContent).data("saph-done",true);	
  	});	  
  }  
  
  	Drupal.behaviors.calcHomeTeaserFullType = function (mainContent) {
		var tabletMobileOverlayOpacity = $(mainContent).data("tablet-mobile-overlay-opacity");
		var tabletMobileOverlayColor = $(mainContent).data("tablet-mobile-overlay-color");
		var desktopOverlayOpacity = $(mainContent).data("desktop-overlay-opacity");
		var desktopOverlayColor = $(mainContent).data("desktop-overlay-color");
		
		if(Drupal.behaviors.globalVariables.currentMediaType == "Desktop"){
			$(".homeTeaserOverlay",mainContent).removeClass("" + desktopOverlayColor + tabletMobileOverlayColor);
			$(".homeTeaserOverlay",mainContent).addClass("" + desktopOverlayColor);	
			$(".homeTeaserOverlay",mainContent).css("opacity",desktopOverlayOpacity);
		}else{
			$(".homeTeaserOverlay",mainContent).removeClass("" + desktopOverlayColor + tabletMobileOverlayColor);
			$(".homeTeaserOverlay",mainContent).addClass("" + tabletMobileOverlayColor);	
			$(".homeTeaserOverlay",mainContent).css("opacity",tabletMobileOverlayOpacity);
		}
		
		var fullHeight = $(mainContent).height();
		var fullWidth = $(mainContent).width();
		var textSectionHeight;
		var saphNavHeaderHeight;
		var textPortraitBottomOffset = 70;
				
		saphNavHeaderHeight = Drupal.behaviors.maxHeightOfNavBar();
		//textSectionHeight = $(".homeTeaserTextSection",mainContent).height();
				
		if(Drupal.behaviors.isPortraitMode()){
			$(".homeTeaserTextSection",mainContent).addClass("col-xs-12");
			$(".homeTeaserTextSection",mainContent).removeClass("col-xs-6");
			
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserTextSection span",mainContent).addClass("h2");
				$(".homeTeaserTextSection span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h2");
				$(".homeTeaserHeadline span",mainContent).addClass("h2");
				$(".homeTeaserHeadline span",mainContent).removeClass("h1-hero");	
			}else{
				$(".homeTeaserTextSection span",mainContent).removeClass("h2");
				$(".homeTeaserTextSection span",mainContent).addClass("h1-hero");		
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).removeClass("h2");		
			}	
			if($(".homeTeaserHeadline .linkButton",mainContent).length){
				$(".homeTeaserHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			var textTopPos = fullHeight-textSectionHeight-textPortraitBottomOffset;
			$(".homeTeaserTextSection",mainContent).css("top",textTopPos);
			textSectionHeight = $(".homeTeaserTextSection",mainContent).height();
			var textTopPos = $(".homeTeaserTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);

		}else{
			$(".homeTeaserTextSection",mainContent).removeClass("col-xs-12");
			$(".homeTeaserTextSection",mainContent).addClass("col-xs-6");

			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserTextSection span",mainContent).addClass("h2");
				$(".homeTeaserTextSection span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h2");
				$(".homeTeaserHeadline span",mainContent).addClass("h2");
				$(".homeTeaserHeadline span",mainContent).removeClass("h1-hero");				
			}else{
				$(".homeTeaserTextSection span",mainContent).removeClass("h2");
				$(".homeTeaserTextSection span",mainContent).addClass("h1-hero");		
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).removeClass("h2");			
			}
			if($(".homeTeaserHeadline .linkButton",mainContent).length){
				$(".homeTeaserHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			textSectionHeight = $(".homeTeaserTextSection",mainContent).height();
			//$(".homeTeaserTextSection",mainContent).css("top",(fullHeight-saphNavHeaderHeight)/2 - textSectionHeight/2 + saphNavHeaderHeight);

			//10% bottom space
			$(".homeTeaserTextSection",mainContent).css("top",fullHeight-textSectionHeight-Math.round((fullHeight/10))); 
		}		
  	};
  
  	Drupal.behaviors.calcHomeTeaserCircleType = function (mainContent) {
		var fullHeight = $(mainContent).height();
		var fullWidth = $(mainContent).width();
		var textSectionHeight;
		var saphNavHeaderHeight;
		var imageMainMaskHeight;
		var imageHeightOffset = 70;
		var textPortraitBottomOffset = 70;
		
		var imageWidth;
		var imageHeight;
		var imageFinalWidth;
		var imageFinalHeight;
		var isBigButton;
		

		Drupal.behaviors.functions.consolog("Drupal.behaviors.calcHomeTeaserCircleType");
		
		saphNavHeaderHeight = Drupal.behaviors.maxHeightOfNavBar();
		
		imageMainMaskHeight = $(".homeTeaserMainImageMask",mainContent).height();
		
		
		if(Drupal.behaviors.isPortraitMode()){
			$(".homeTeaserTextSection",mainContent).addClass("col-xs-12");
			$(".homeTeaserTextSection",mainContent).removeClass("col-xs-6");
			
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-12");
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-7 col-xs-offset-5");

			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserTextSection span",mainContent).addClass("h2");
				$(".homeTeaserTextSection span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h2");
				$(".homeTeaserHeadline span",mainContent).addClass("h2");
				$(".homeTeaserHeadline span",mainContent).removeClass("h1-hero");
			}else{
				$(".homeTeaserTextSection span",mainContent).removeClass("h2");
				$(".homeTeaserTextSection span",mainContent).addClass("h1-hero");		
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).removeClass("h2");
			}
			if($(".homeTeaserHeadline .linkButton",mainContent).length){
				$(".homeTeaserHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			textSectionHeight = $(".homeTeaserTextSection",mainContent).height();
			var textTopPos = fullHeight-textSectionHeight-textPortraitBottomOffset;
			$(".homeTeaserTextSection",mainContent).css("top",textTopPos);
			//$(".homeTeaserTextSection",mainContent).css("bottom",textPortraitBottomOffset);
			
			imageWidth = $(".homeTeaserMainImageMask",mainContent).width();
			imageHeight = imageMainMaskHeight-saphNavHeaderHeight-imageHeightOffset-textSectionHeight-textPortraitBottomOffset;
			
			if(imageWidth>imageHeight){
				imageFinalWidth = imageFinalHeight = imageHeight;
			}else{
				imageFinalWidth = imageFinalHeight = imageWidth;
			}
			$(".homeTeaserCircleMask",mainContent).width(imageFinalWidth);
			$(".homeTeaserCircleMask",mainContent).height(imageFinalHeight);
			$(".homeTeaserCircleMask",mainContent).css("top", (imageMainMaskHeight-saphNavHeaderHeight-textSectionHeight-textPortraitBottomOffset)/2 - imageFinalHeight/2 + saphNavHeaderHeight);

		}else{
			$(".homeTeaserTextSection",mainContent).removeClass("col-xs-12");
			$(".homeTeaserTextSection",mainContent).addClass("col-xs-6");

			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-12");
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-7 col-xs-offset-5");

			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserTextSection span",mainContent).addClass("h2");
				$(".homeTeaserTextSection span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h2");
				$(".homeTeaserHeadline span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h2");
			}else{
				$(".homeTeaserTextSection span",mainContent).removeClass("h2");
				$(".homeTeaserTextSection span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).removeClass("h2");
			}
			if($(".homeTeaserHeadline .linkButton",mainContent).length){
				$(".homeTeaserHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			textSectionHeight = $(".homeTeaserTextSection",mainContent).height();
			//$(".homeTeaserTextSection",mainContent).css("top",(fullHeight-saphNavHeaderHeight)/2 - textSectionHeight/2 + saphNavHeaderHeight);
			
			//10% bottom space
			$(".homeTeaserTextSection",mainContent).css("top",fullHeight-textSectionHeight-Math.round((fullHeight/10))); 
			
			imageWidth = $(".homeTeaserMainImageMask",mainContent).width();
			imageHeight = imageMainMaskHeight-saphNavHeaderHeight-imageHeightOffset;
			
			if(imageWidth>imageHeight){
				imageFinalWidth = imageFinalHeight = imageHeight;
			}else{
				imageFinalWidth = imageFinalHeight = imageWidth;
			}
			$(".homeTeaserCircleMask",mainContent).width(imageFinalWidth);
			$(".homeTeaserCircleMask",mainContent).height(imageFinalHeight);
			$(".homeTeaserCircleMask",mainContent).css("top",(imageMainMaskHeight-saphNavHeaderHeight - imageHeightOffset)/2 - imageFinalHeight/2 + saphNavHeaderHeight);
		}
	};
  
	
  	Drupal.behaviors.calcHomeTeaserRectType = function (mainContent) {
		var fullHeight = $(mainContent).height();
		var fullWidth = $(mainContent).width();
		var textSectionHeight;
		var saphNavHeaderHeight;
		var imageMainMaskHeight;
		var imageMainMaskWidth;
		var imageHeightOffset = 70;
		var textPortraitBottomOffset = 70;
		var separationSize = 30;
		
		var imageWidth;
		var imageHeight;
		var imageFinalWidth;
		var imageFinalHeight;
		
		Drupal.behaviors.functions.consolog("Drupal.behaviors.calcHomeTeaserRectType");		
		saphNavHeaderHeight = Drupal.behaviors.maxHeightOfNavBar();
		
		if(Drupal.behaviors.isPortraitMode()){
			$(".homeTeaserTextSection",mainContent).addClass("col-xs-12");
			$(".homeTeaserTextSection",mainContent).removeClass("col-xs-6");
			
			//$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-12");
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-6 col-xs-offset-6");
			//$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-6 col-xs-offset-3");
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3");



			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserTextSection span",mainContent).addClass("h2");
				$(".homeTeaserTextSection span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h2");
				$(".homeTeaserHeadline span",mainContent).addClass("h2");
				$(".homeTeaserHeadline span",mainContent).removeClass("h1-hero");
			}else{
				$(".homeTeaserTextSection span",mainContent).removeClass("h2");
				$(".homeTeaserTextSection span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).removeClass("h2");
			}
			if($(".homeTeaserHeadline .linkButton",mainContent).length){
				$(".homeTeaserHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			textSectionHeight = $(".homeTeaserTextSection",mainContent).height();			
			var textTopPos = fullHeight-textSectionHeight-textPortraitBottomOffset;
			$(".homeTeaserTextSection",mainContent).css("top",textTopPos);
			
			imageMainMaskHeight = $(".homeTeaserMainImageMask",mainContent).height();
			imageMainMaskWidth = $(".homeTeaserMainImageMask",mainContent).width();
			imageFinalHeight = imageMainMaskHeight - saphNavHeaderHeight - imageHeightOffset - textSectionHeight - textPortraitBottomOffset - separationSize;
			imageFinalWidth = (imageMainMaskWidth * 0.80) - separationSize;
			
			$(".homeTeaserRectangleMask1",mainContent).width(imageFinalWidth);
			$(".homeTeaserRectangleMask1",mainContent).height(imageFinalHeight);
			$(".homeTeaserRectangleMask2",mainContent).width(imageFinalWidth);
			$(".homeTeaserRectangleMask2",mainContent).height(imageFinalHeight);
			var centerImagePos = (imageMainMaskHeight- saphNavHeaderHeight - textSectionHeight - textPortraitBottomOffset)/2 - imageFinalHeight/2 + saphNavHeaderHeight;
			$(".homeTeaserRectangleMask2",mainContent).css("right",imageMainMaskWidth/2 - imageFinalWidth/2 -  separationSize/2);
			$(".homeTeaserRectangleMask2",mainContent).css("top",centerImagePos + (separationSize/2));
			$(".homeTeaserRectangleMask1",mainContent).css("right",imageMainMaskWidth/2 - imageFinalWidth/2 +  separationSize/2);
			$(".homeTeaserRectangleMask1",mainContent).css("top",centerImagePos - (separationSize/2));
		}else{

			$(".homeTeaserTextSection",mainContent).removeClass("col-xs-12");
			$(".homeTeaserTextSection",mainContent).addClass("col-xs-6");

			//$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-12");
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-6 col-xs-offset-3");			
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-6 col-xs-offset-6");


			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserTextSection .linkTextSaph, .homeTeaserTextSection span",mainContent).addClass("h2");
				$(".homeTeaserTextSection .linkTextSaph, .homeTeaserTextSection span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h2");
				$(".homeTeaserHeadline span",mainContent).removeClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).addClass("h2");
			}else{
				$(".homeTeaserTextSection .linkTextSaph, .homeTeaserTextSection span",mainContent).removeClass("h2");
				$(".homeTeaserTextSection .linkTextSaph, .homeTeaserTextSection span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserHeadline .linkButton",mainContent).data("text-class","h1-hero");	
				$(".homeTeaserHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserHeadline span",mainContent).removeClass("h2");
			}
			if($(".homeTeaserHeadline .linkButton",mainContent).length){
				$(".homeTeaserHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			textSectionHeight = $(".homeTeaserTextSection",mainContent).height();
			//$(".homeTeaserTextSection",mainContent).css("top",(fullHeight-saphNavHeaderHeight)/2 - textSectionHeight/2 + saphNavHeaderHeight);

			//10% bottom space
			$(".homeTeaserTextSection",mainContent).css("top",fullHeight-textSectionHeight-Math.round((fullHeight/10))); 
			
			imageMainMaskHeight = $(".homeTeaserMainImageMask",mainContent).height();
			imageMainMaskWidth = $(".homeTeaserMainImageMask",mainContent).width();
			imageFinalHeight = imageMainMaskHeight - saphNavHeaderHeight - imageHeightOffset - separationSize;
			imageFinalWidth = (imageMainMaskWidth * 0.80) - separationSize;
			
			$(".homeTeaserRectangleMask1",mainContent).width(imageFinalWidth);
			$(".homeTeaserRectangleMask1",mainContent).height(imageFinalHeight);
			$(".homeTeaserRectangleMask2",mainContent).width(imageFinalWidth);
			$(".homeTeaserRectangleMask2",mainContent).height(imageFinalHeight);
			
			var centerImagePos = (imageMainMaskHeight-saphNavHeaderHeight-imageHeightOffset)/2 - imageFinalHeight/2 + saphNavHeaderHeight;
			$(".homeTeaserRectangleMask2",mainContent).css("right",0);
			$(".homeTeaserRectangleMask2",mainContent).css("top",centerImagePos + (separationSize/2));
			$(".homeTeaserRectangleMask1",mainContent).css("right",separationSize);
			$(".homeTeaserRectangleMask1",mainContent).css("top",centerImagePos - (separationSize/2));
		}
	};
  
	Drupal.behaviors.changeHomeTeaserMode = function () {
		$(".homeTeaser").each(function (index){
			var mainContent = $(this);
			$(mainContent).height($(window).height());
			//var footerNavText = $(mainContent).data("footer-nav");
			var maskType = $(mainContent).data("mask-type");	
	    	
			
			//When the mask type is full	    	
			if(maskType == "full"){
				Drupal.behaviors.calcHomeTeaserFullType(mainContent);
			} else if(maskType == "circle"){
				Drupal.behaviors.calcHomeTeaserCircleType(mainContent);
			} else if(maskType == "rectangle"){
				Drupal.behaviors.calcHomeTeaserRectType(mainContent);
			}
		});
	}; 

})(jQuery);